import { Directive, Input, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
	selector: "input[obgTrimWhitespaceValue]",
})
export class TrimWhitespaceInputValueDirective {
	@Input() obgTrimWhitespaceValue = false;

	constructor(private ngControl: NgControl) {}

	@HostListener("blur", ["$event.target.value"])
	onBlur(value: string) {
		if (this.obgTrimWhitespaceValue) {
			const trimmedWhitespaceValue = value.replace(/\s/g, "");
			this.ngControl.control?.setValue(trimmedWhitespaceValue);
		}
	}
}
